/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_accounts_funds_to = /** @type {(inputs: {}) => string} */ () => {
	return `Fondos a`
};

const en_accounts_funds_to = /** @type {(inputs: {}) => string} */ () => {
	return `Funds to`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const accounts_funds_to = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.accounts_funds_to(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("accounts_funds_to", locale)
	if (locale === "es") return es_accounts_funds_to(inputs)
	return en_accounts_funds_to(inputs)
};
export { accounts_funds_to as "accounts.funds_to" }